import { h } from '@stencil/core';
import { EvaButtonSize, EvaButtonVariant } from './types/eva-types';

export interface EvaButtonProps {
  text?: string;
  size: EvaButtonSize;
  onClick?: (...args: any[]) => void;
  variant?: EvaButtonVariant;
  icon?: string;
  rootElementClasses?: string;
  disabled?: boolean;
}

export default function EvaButton({ text, variant = '-primary', size, onClick, icon, rootElementClasses = '', disabled = false }: EvaButtonProps) {
  const isGhost = variant.includes('ghost');
  const actualVariant = isGhost ? variant.replace('-ghost', '') : variant;
  const buttonTypeClass = isGhost ? 'eva-3-btn-ghost' : 'eva-3-btn';
  const iconMarginClass = text ? '-eva-3-ml-md' : '';
  return (
    <button class={`${buttonTypeClass} ${actualVariant} -${size} ${rootElementClasses} ${disabled ? 'disabled' : ''}`} disabled={disabled} onClick={onClick}>
      {text && <em class="btn-text">{text}</em>}
      {icon && <i class={`${iconMarginClass} btn-icon eva-3-icon-${icon} -eva-3-icon-xsm`} />}
    </button>
  );
}
